import {IParams, RecursosController} from "../recursos";

declare global {
    interface Window {
        instgrm: any;
    }
}

export class InstagramController extends RecursosController {

    /* INSTANCE */
    public static instance: InstagramController;

    /* STATIC */
    public static override async build(): Promise<void> {
        InstagramController.instance = new this();
        RecursosController.instances.push(InstagramController.instance);
    }

    constructor() {
        super();
        this.getResources(document.body).then(async()=>{
            await this.init();
            this.scrollEvent = this.lazyResources.bind(this);
            document.addEventListener("scroll", this.scrollEvent);
        });
    }

    protected async getResources(html: HTMLElement): Promise<void> {
        const resources = Array.from(html.querySelectorAll("[class*='instagram-body'], [class*='instagram-live']"));
        for (let resource of resources) this.resources.push(resource as HTMLElement);
    }

    protected async load(item: HTMLElement) : Promise<void> {
        const urls: IParams[] = [{name: "script-instagram", value: "https://www.instagram.com/embed.js"}];
        const promesas = await this.initPromises(urls);
        await Promise.all(promesas).then(async ()=>{
            item.innerHTML = item.getAttribute("data-lazy") as string;
            window.instgrm.Embeds.process();
        });
    }

}
